import { render, staticRenderFns } from "./yes-no.vue?vue&type=template&id=cb2aa40c"
import script from "./yes-no.vue?vue&type=script&lang=js"
export * from "./yes-no.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports